const events = {
  all: 'Tous',
  categories: {
    ACCESS: 'Accès',
    ALARM: 'Alarme',
    CONFIGURATION: 'Configuration',
    DETAILED_ACCESS: 'Accès détaillé',
    HARDWARE: 'Matériel',
    INTEGRATION: 'Intégration',
    SYSTEM: 'Système',
    WARNING: 'Avertissement',
  },
  general: {
    add: 'Ajouter',
    assign: 'Attribuer',
    fetchError: 'Impossible de récupérer les données',
  },
  selectors: {
    selector2: {
      security: 'Sécurité',
      lockdown: 'Confinement',
    },
    selector3: {
      user: 'Utilisateur',
    },
  },
  table: {
    object: 'Objet',
    instigator: 'Instigateur',
  },
};

export default events;
